import React from "react";
const UserContext = React.createContext(); //Context of the current logged in user
export default UserContext;
